export { btnColor, syncing } from "../suggestion-action-colors/SuggestionActionColors.styles";

export const icon = {
  height: 20,
  width: 20,
  marginLeft: 5,
  marginRight: 5,
};
